export default __webpack_public_path__ + "static/media/ideal-logo.511817be.svg";